<template>
<div class="partner-module">
  <div class="partner-module-logo">
    <a :href="link" target="_blank"><slot name="partner-logo"></slot></a>
  </div>
  <div class="partner-module-name">
    <a  :href="link" target="_blank">
      <slot name="partner-name"></slot>
    </a>
  </div>
  <div class="partner-module-intro">
    <slot name="partner-intro"></slot>
  </div>
</div>
</template>

<script>
export default {
  props: ['link']
}
</script>

<style lang="scss" scoped>
.partner-module {
  width: 320px;
  margin: 0 auto;
  margin-top: 1.5rem;
  box-sizing: border-box;

  &-logo {
    text-align: center;
    line-height: 4.5rem;
    height: 4.5rem;
  }

  &-name {
    @include nkn-font-set(.9rem, #1791f2);
    line-height: 2.5rem;
    text-align: center;

    @media screen and (max-width: 768px) {
      margin-top: 2rem;
    }

    a {
      &:hover {
        color: #51B2FF !important;
      }
    }
  }

  &-intro {
    @include nkn-font-set(.75rem, $common-color, 400);
    line-height: 1rem;
    text-align: justify;

    p {
      white-space: pre-line;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partner/plugins/PartnerModule.vue